'use strict';

angular.module('cimerFrontEndApp').directive('surveySection',[function() {
    return {
        restrict: 'EA',
        templateUrl: '/Content/Templates/survey/sectionTemplate.html',
        scope: {
            sectionObject: '=surveySection',
            displayOnly: '=displayOnly',
            showDisplayLogic: '=showDisplayLogic'
        }
    };
}]);
